import { render } from "./Textarea.vue?vue&type=template&id=0541cb9a&scoped=true&ts=true"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=0541cb9a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0541cb9a"]])

export default __exports__